/**
 * 页面分页加载组件
 * @author wangdi
 */

import ListLoader from './src/wdListLoader';
import PageIndexNav from './src/wdPageIndexNav';

export {
    ListLoader,
    PageIndexNav
}
